<template lang="html">
    <div class="recommendation-item">
        <div class="checkbox-wrap">
          <CustomCheckbox
            :is-checked="isChecked"
            @toggle="$emit('toggle', localItem.id)"
          />
        </div>
        <div
          class="phrase-wrap"
          :class="{'is-invalid': isInvalid}"
        >
          <input
            ref="input"
            v-model="localItem.synonym"
            class="phrase-input"
            :disabled="!isEditing"
            @input="$emit('update', localItem)"
          />
          <div
            v-if="isEditing"
            class="icon-btns-wrap"
          >
            <or-icon-button
              type="secondary"
              icon="close"
              size="small"
              class="flat"
              disableRipple
              @click="onDiscardChanges"
            ></or-icon-button>
            <or-icon-button
              type="secondary"
              icon="done"
              size="small"
              disableRipple
              class="flat"
              @click="onSavePhrase"
            ></or-icon-button>
          </div>
          <div
            v-else
            class="icon-btns-wrap"
          >
            <or-icon-button
              v-show="showEditButton"
              class="flat"
              type="secondary"
              icon="edit"
              size="small"
              disableRipple
              @click="onEdit"
            ></or-icon-button>
            <PinIconMask
              :is-pinned="isPinned"
              @click="$emit('pin', localItem.id)"
            />
          </div>
        </div>
    </div>
</template>
<script>
import clone from 'lodash/clone'
import trim from 'lodash/trim'
import CustomCheckbox from '@/components/common/custom_checkbox'
import PinIconMask from '@/assets/pin_icon_mask'

export default {
  components: {
    CustomCheckbox,
    PinIconMask
  },

  created () {
    this.localItem = clone(this.$props.item)
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    selectedPhrases: {
      type: Array,
      default: () => ([])
    },
    notValidPhrases: {
      type: Array,
      default: () => ([])
    },
    pinnedPhrases: {
      type: Array,
      default: () => ([])
    },
    editingPhrase: {
      type: String,
      default: null
    },
    invalidPhrase: {
      type: String,
      default: null
    }
  },

  computed: {
    isChecked () {
      return this.selectedPhrases.includes(this.item.id)
    },

    isPinned () {
      return this.pinnedPhrases.includes(this.item.id)
    },

    showEditButton () {
      return !this.editingPhrase
    },

    isInvalid () {
      return this.localItem.id === this.invalidPhrase
    }
  },

  data () {
    return {
      phraseBeforeEdit: '',
      isEditing: false
    }
  },

  methods: {
    onEdit () {
      this.phraseBeforeEdit = clone(this.localItem.synonym)
      this.$emit('editing-phrase::set', this.localItem.id)
      this.isEditing = true

      this.$nextTick(() => this.$refs.input.focus())
    },

    isPhraseEmpty (phrase) {
      return trim(phrase).length === 0
    },

    onSavePhrase () {
      if (this.isPhraseEmpty(this.localItem.synonym)) {
        this.$emit('empty-phrase-error::show', true)
        this.$emit('invalid-phrase::set', this.localItem.id)

        return
      }

      this.localItem.synonym = trim(this.localItem.synonym)
      this.$emit('empty-phrase-error::show', false)
      this.$emit('invalid-phrase::set', null)
      this.$emit('editing-phrase::set', null)
      this.isEditing = false
    },

    onDiscardChanges () {
      this.localItem.synonym = this.phraseBeforeEdit
      this.$emit('empty-phrase-error::show', false)
      this.$emit('invalid-phrase::set', null)
      this.isEditing = false
      this.$emit('editing-phrase::set', null)
    }
  }
}
</script>
<style lang="scss" scoped>
.recommendation-item {
    display: flex;
    flex-grow: 1;
    min-height: 36px;
    border: solid 1px $or-grey-medium;
    margin-bottom: -1px;

    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .checkbox-wrap {
      display: flex;
      align-items: center;
      border-right: solid 1px $or-grey-medium;
      padding: 0 10px;
    }

    .phrase-wrap {
      display: flex;
      flex-grow: 1;
      align-items: center;
      padding-left: 8px;

      &.is-invalid {
        transition: all 0.2s ease;
        border: solid 1px $or-red;
      }

      .phrase-input {
        width: 100%;
        font-size: 14px;
        color: $or-black-blue;
        border: none;
        outline: none;
        background-color: transparent;
      }
    }

    .icon-btns-wrap {
      display: flex;
      align-items: center;
    }
}
</style>
